import React, { useContext } from 'react';
import { FaBell, FaCheckDouble, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import CusNotiList from '../../../subscreens/customer/CustomerNotifications/CusNotiList.js';
import '../../../assets/css/customer/customerNotifications.css';

const CustomerNotifications = () => {
  const { authToken, baseUrl, customerId, notifications, setnotification } = useContext(AppContext);

  const unreadCount = notifications.filter((n) => n.status === 'unread').length;

  const stats = [
    { label: 'Total', value: notifications.length, icon: '🔔', bg: '#E8F4F8', color: '#2C5F7C' },
    { label: 'Unread', value: unreadCount, icon: '📩', bg: '#FFF8E1', color: '#FFB800' },
    { label: 'Read', value: notifications.length - unreadCount, icon: '✅', bg: '#E8F8EA', color: '#28A745' },
  ];

  const handleMarkAllRead = () => {
    axios
      .post(
        `${baseUrl}/customer/mark-all-read`,
        { customer_id: customerId },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then(() => {
        setnotification((prev) => prev.map((n) => ({ ...n, status: 'read' })));
      })
      .catch((err) => console.error('Mark all read error:', err));
  };

  const handleClearAll = () => {
    if (!window.confirm('Delete all read notifications? This cannot be undone.')) return;

    axios
      .delete(`${baseUrl}/customer/delete-all-read`, {
        headers: { Authorization: `Bearer ${authToken}` },
        data: { customer_id: customerId },
      })
      .then(() => {
        setnotification((prev) => prev.filter((n) => n.status !== 'read'));
      })
      .catch((err) => console.error('Clear all error:', err));
  };

  return (
    <div className="jj-fade-in-up">
     
      <div className="cus-noti-page">
        {/* Header card */}
        <div className="cus-noti-header">
          <div className="cus-noti-header-left">
            <div className="cus-noti-bell">
              <FaBell />
              {unreadCount > 0 && <span className="cus-noti-badge">{unreadCount}</span>}
            </div>
            <div className="cus-noti-header-text">
              <h1>Notifications</h1>
              <p>
                {unreadCount > 0
                  ? `You have ${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}`
                  : "You're all caught up!"}
              </p>
            </div>
          </div>

          <div className="cus-noti-header-actions">
            {unreadCount > 0 && (
              <button className="cus-noti-btn" onClick={handleMarkAllRead}>
                <FaCheckDouble /> Mark All Read
              </button>
            )}
            {notifications.filter((n) => n.status === 'read').length > 0 && (
              <button className="cus-noti-btn danger" onClick={handleClearAll}>
                <FaTrashAlt /> Clear Read
              </button>
            )}
          </div>
        </div>

        {/* Stats row */}
        <div className="cus-noti-stats">
          {stats.map((s) => (
            <div key={s.label} className="cus-noti-stat-card">
              <div className="cus-noti-stat-icon" style={{ backgroundColor: s.bg }}>
                <span style={{ fontSize: '22px' }}>{s.icon}</span>
              </div>
              <div>
                <p className="cus-noti-stat-value">{s.value}</p>
                <p className="cus-noti-stat-label">{s.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Tab and list */}
        <CusNotiList />
      </div>
    </div>
  );
};

export default CustomerNotifications;